import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CardContext, ICardContext } from 'context/cardContext';
import CardImageTextArea from 'components/Card/components/CardImageTextArea';
import CardAnimatedContent from 'components/Card/components/CardAnimatedContent';
import CardMatchStartTime from 'components/Card/components/CardMatchStartTime';
import CardRevealCopy from 'components/Card/components/CardRevealCopy';
import CardMatchHasStarted from 'components/Card/components/CardMatchHasStarted';
import missedImg from 'theme/assets/images/missed.png';

import './CardView.scss';

const CardView = () => {
  const { t } = useTranslation();
  const { isFullTime, loading, canBeRevealed, hasExpired, eventActive, handleOnClick, revealed, matchHasStarted, noEntry, stubbedMode, eventParticipants } = useContext<ICardContext>(CardContext);

  const getCardClasses = () => {
    let classes = 'card';
    if (isFullTime) classes = classes + ' card--full-time';
    if (loading) classes = classes + ' card--loading';
    return classes;
  };

  return (
    <div className={getCardClasses()}>
      <button className={`card__button`} disabled={(loading || !canBeRevealed || hasExpired) && eventActive} onClick={handleOnClick}>
        <div className="card__layer" aria-hidden="true">
          <CardAnimatedContent />
          <div className="card__footer-html">
            {revealed && eventParticipants ? <>{matchHasStarted && eventActive ? <CardMatchHasStarted /> : <CardMatchStartTime />}</> : <>{!hasExpired && <CardRevealCopy />}</>}
          </div>
        </div>

        {/* Missed player */}
        {hasExpired && !revealed && (
          <div className="card__layer" aria-hidden="true">
            <CardImageTextArea image={missedImg} />
            {(!noEntry || stubbedMode) && (
              <div className="card__footer-html">
                <span className="card__missed-player">{t('expired')}</span>
              </div>
            )}
          </div>
        )}
      </button>
    </div>
  );
};

export default CardView;
